import React from 'react';
import { useContent } from '../hooks/useContent';

const FaqPage: React.FC = () => {
  const { content, loading } = useContent();

  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <div className="text-white text-xl">Loading FAQs...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex flex-col items-center py-8 sm:py-12 px-4">
      {/* CHANGED: smaller heading on mobile */}
      <h1 className="text-2xl sm:text-4xl font-bold mb-6 sm:mb-8 text-white tracking-wider">
        FAQ
      </h1>

      {/* CHANGED: full width on mobile with horizontal padding, max-w on sm+ */}
      <div className="w-full max-w-2xl space-y-4 sm:space-y-6">
        {content.faqs.map((faq) => (
          <div
            key={faq.id}
            className="rounded-xl p-4 sm:p-6 bg-[#181225]/80 border border-[#35353f] shadow flex flex-col"
          >
            {/* CHANGED: slightly smaller question text on mobile */}
            <div className="text-base sm:text-lg font-semibold text-red-500 mb-2">
              {faq.question}
            </div>
            <div className="text-white text-sm sm:text-base leading-relaxed">
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;